import {
    UPDATE_WORK_PREFRENCE_REQUEST,
    UPDATE_WORK_PREFRENCE_SUCCESS,
    UPDATE_WORK_PREFRENCE_FAIL,
  } from "../constants/AuthConstant";


  const initialState = {
    loading: false,
    result: null,
    msg: "",
    error: "",
  };


  const UpdateWorkPrefrenceReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_WORK_PREFRENCE_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case UPDATE_WORK_PREFRENCE_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case UPDATE_WORK_PREFRENCE_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };

  export default UpdateWorkPrefrenceReducer